import { desktopBlur, type CardDirection, type FlowThemeCardMotion } from '../../cardMotion';

/** The card surfaces out of the sea mist, and the last one fades back into it. */
export const lighthouseCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const drift = isMobile ? 22 : 34;
  return {
    variants: {
      enter: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? drift : -drift, scale: 0.97, filter: desktopBlur(isMobile, 8) }),
      center: { opacity: 1, x: 0, scale: 1, filter: isMobile ? undefined : 'blur(0px)' },
      exit: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? -drift : drift, scale: 1.02, filter: desktopBlur(isMobile, 10) }),
    },
    transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
  };
};
